import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/use-auth';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { StandortAdminBanner } from './StandortAdminBanner';
import { SimulationsBanner } from './SimulationsBanner';
import ReportBugButton from '../testing/ReportBugButton';

const SIDEBAR_COLLAPSED_KEY = 'sidigo-sidebar-collapsed';
const DashboardLayout = () => {
  const {
    user
  } = useAuth();
  const location = useLocation();
  const isStandortAdminRoute = location.pathname.startsWith('/standort');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
      setSidebarCollapsed(saved === '1');
    } catch {
      setSidebarCollapsed(false);
    }
  }, []);

  const toggleSidebarCollapsed = () => {
    setSidebarCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? '1' : '0');
      } catch {
        // best effort persistence
      }
      return next;
    });
  };

  if (!user) {
    return null;
  }
  return <div className="flex h-screen overflow-hidden">
      {/* Sidebar for larger screens */}
      <div className="hidden shrink-0 md:flex">
        <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={toggleSidebarCollapsed} showToggle />
      </div>
      <div className="hidden w-px shrink-0 bg-border/70 md:block" aria-hidden="true" />
      {/* Mobile sidebar */}
      {sidebarOpen && <div className="fixed inset-0 z-40 md:hidden">
          <button
            type="button"
            aria-label="Sidebar schließen"
            className="fixed inset-0 bg-foreground/30 backdrop-blur-[1px] motion-safe:animate-fade-up"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="chrome-glass fixed inset-y-0 left-0 z-40 w-64 shadow-surface motion-safe:animate-fade-up">
            <Sidebar />
          </div>
        </div>}
      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {isStandortAdminRoute && <StandortAdminBanner />}
          <SimulationsBanner />
          <Outlet />
        </main>
        {/* Nur Beta-Testphase: von jeder Seite aus melden, ohne sie zu verlassen. */}
        <ReportBugButton />
      </div>
    </div>;
};
export default DashboardLayout;